/* ca-home.js: só a home. A paralaxe ([data-px], [data-pp]) e o fade da colagem (classe "ready") são do site.js.
   Aqui: depois de assinar a newsletter, a página volta do envio no topo; levamos o leitor até a mensagem de
   enviado ou de erro, que fica no fim da página. Inicia no carregamento e quando o editor recarrega a seção. */
(function(){
  function iniciarNewsletter(raiz){
    var msg=(raiz||document).querySelector('.hm-news [data-hm-msg]');
    if(!msg)return;
    var reduzir=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sec=msg.closest('.hm-news')||msg;
    try{sec.scrollIntoView({behavior:reduzir?'auto':'smooth',block:'center'});}catch(e){sec.scrollIntoView();}
  }
  function iniciar(){
    if(window.Shopify&&Shopify.designMode)return; /* no editor não rola sozinho */
    iniciarNewsletter(document);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',iniciar);else iniciar();
  document.addEventListener('shopify:section:load',function(ev){
    if(ev.target&&ev.target.querySelector&&ev.target.querySelector('.hm-news'))iniciarNewsletter(ev.target);
  });
})();
